export const create = {
  form: {
    name: '水洗機部品名',
    manufacturer: 'メーカー名',
    supplier: '発注先',
    price: '価格/円',
    inventory: '在庫数',
    addNew: '新規追加',
    requireName: '水洗機部品名を入力してください',
    requireManufacture: 'ﾒｰｶｰ名を入力してください',
    requireSupplier: '発注先を入力してください',
    requirePrice: '価格/円を入力してください',
    requireInventory: '在庫数を入力してください',
  },
  pageHeader: {
    title: '部品リスト　新規追加画面',
    back: '戻る',
  },
}
